export default "assets/images/icons/linkedin-6a1ba754.svg";